import styled from 'styled-components';
import * as antd from 'antd';

export const Button = styled(antd.Button)`
  margin: 5px;
`;